module.exports = __webpack_public_path__ + "static/img/11-Newcastle-Helix.74a1678a.jpg";